import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { IOption } from "ng-select";
import { NgForm } from "@angular/forms";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { HelperService } from "../../services/helper.service";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ConfigurationService } from "../../services/configuration.service";
import { TosterMessageService } from "../../services/toster-message.service";


@Component({
  selector: "app-objective-ratings-master-modal.component",
  templateUrl: "./objective-ratings-master-modal.component.html",
  providers: [ConfigurationService],
})
export class ObjectiveRatingsMasterAddComponent implements OnInit {
  public masterData: any = {};

  @Output() public ObjectiveRatingMasterReload: EventEmitter<any> = new EventEmitter<any>();
  @Output() tableReload: EventEmitter<any> = new EventEmitter();

  formData = {
    description: "",
    //   active: 0,
  };

  gapStatus = [
    { value: 0, label: "No" },
    { value: 1, label: "Yes" },
  ];

  isEdit: number;
  public items: Array<IOption> = [];
  auto_id: number;

  activeStatus = [
    { value: 0, label: "No" },
    { value: 1, label: "Yes" },
  ];



  @ViewChild("form") form: NgForm;
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = +this.helperService.getSelectedCompanyId();



  constructor(
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private helperService: HelperService,
    private configurationService: ConfigurationService,
    private tosterMessageService: TosterMessageService,
  ) {}

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  ngOnInit() {}

  addRatingMaster(formData: any) {
    const activeValue = formData.active === undefined ? 0 : formData.active;
    const isGapAnalysis = formData.is_gap_analysis || 0;
    const requestData = {
      description: formData.description,
      active: activeValue,
      company_id: this.companySystemID,

      order: formData.order,
      points: formData.points,
      is_gap_analysis: isGapAnalysis,
    };
    let that = this;
    that.masterData.companySystemID = that.companySystemID;
    that.configurationService
      .addNewObjectiveRatings()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          that.masterData = {};
          that.successMsg = "";
          that.successMsg = "Successfully added objective ratings master";
          that.showSuccessHtml();
          that.closeModalAfterCreate();
          this.ObjectiveRatingMasterReload.emit();
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(
              error.data.message
            );
            that.showErrorHtml();
            this.ObjectiveRatingMasterReload.emit();
          }
        }
      );
    this.ObjectiveRatingMasterReload.emit();
  }



  editRatingMaster() {
    let that = this;
    const requestData = {
      auto_id: that.auto_id,
      items: that.items,
    };
    that.configurationService
      .editRatingMaster()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          this.tosterMessageService.showSuccess(
            "Success",
            "Rating Master Successfully Updated."
          );
          that.closeModalAfterCreate();
          this.tableReload.emit();
        },
        (error) => {
          //console.log(error);
          this.tosterMessageService.showError("Sorry","Invalid input!.");
          that.closeModalAfterCreate();
        }
      );
    this.tableReload.emit();
  }


  getRoleStatusPlaceholder(active: number): string {
    return active === 1 ? 'Active' : 'Not Active';
  }


  getIsGapStatusPlaceholder(is_gap_analysis: number): string {
    return is_gap_analysis === 1 ? 'Yes' : 'No';
  }
  
}



// WEBPACK FOOTER //
// /app/src/app/configuration/objective-ratings-master-modal/objective-ratings-master-modal.component.ts